"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuButton = void 0;
const index_1 = require("./index");
const pixi_js_1 = require("pixi.js");
const WigglyText_1 = require("../objects/WigglyText");
const Global_1 = require("../Global");
class MenuButton extends index_1.Block {
    constructor(app, text, color, w = 145, h = 145, padding = 0, radius = 4, font = 40) {
        super(app);
        this.text = text;
        this.color = color;
        this.w = w;
        this.h = h;
        this.padding = padding;
        this.radius = radius;
        this.font = font;
        this.background = new pixi_js_1.Graphics();
        // TODO: Make sure this gets cleaned up
        this.wiggleText = new WigglyText_1.WigglyText(this.app, this.text, index_1.Block.textStyle(this.font));
        this.background.name = 'box';
        this.wiggleText.name = 'text';
        this.wiggleText.anchor.set(0.5, 1.0);
        this.addChild(this.background, this.wiggleText);
        this.layout();
    }
    set textColor(color) {
        this.wiggleText.style.fill = color;
    }
    updateBackground(border = 2) {
        return this.makeBox({
            borderColor: 0x222222,
            border: border,
            backgroundColor: this.color,
            vertical: false,
            width: this.w,
            height: this.h,
            radius: this.radius
        }, this.background);
    }
    // Just to get Typescript to stop wining :(
    setTransform(x, y, scaleX, scaleY, rotation, skewX, skewY, pivotX, pivotY) {
        return super.setTransform(x, y, scaleX, scaleY, rotation, skewX, skewY, pivotX, pivotY);
    }
    layout() {
        this.updateBackground();
        this.wiggleText.style.fontSize = (0, Global_1.fontSize)(this.font);
        // Squeeze text into box
        const fitratio = this.wiggleText.width / ((this.background.width - (0, Global_1.px)(4)) || this.wiggleText.width);
        if (fitratio > 1) {
            this.wiggleText.scale.x = 1 / fitratio;
        }
        this.wiggleText.position.set(this.background.width / 2, this.background.height - (0, Global_1.px)(this.padding));
    }
}
exports.MenuButton = MenuButton;
